<!-- Delivery/Pickup Form Modal -->
<div class="delivery-form-modal" [class.open]="isOpen">
  <div class="modal-overlay" (click)="closeForm()"></div>
  <div class="modal-content form-content" (click)="$event.stopPropagation()">
    <div class="form-header">
      <h2 >{{ offersBothFulfillmentMethods() ? ('orderDetails.deliveryForm.title.choose' | translate) : ('orderDetails.deliveryForm.title.default' | translate) }}</h2>
      <button class="close-button" (click)="closeForm()">
        <img src="../../../assets/x.svg" alt="Close">
      </button>
    </div>

    <div class="form-body" (click)="closeCommunicationDropdown()">
      <!-- Delivery Type Selector (shown only if both delivery and pickup are available) -->
      <div class="form-section" *ngIf="!isAddressReadOnly && shouldShowDeliveryTypeSelector()">
        <div class="delivery-method-wrapper">
          <i class="section-icon icon-delivery" aria-hidden="true"></i>
          <div>
            <label class="form-label">{{ 'orderDetails.deliveryForm.deliveryType.label' | translate }}</label>
            <p class="form-description">{{ 'orderDetails.deliveryForm.deliveryType.description' | translate }}</p>
          </div>
        </div>
        <hr>
        <div class="delivery-type-selector">
          <button class="delivery-type-btn" [class.active]="deliveryType === 'delivery'"
            (click)="deliveryType = 'delivery'; onDeliveryTypeChange()">
            <img src="../../../assets/house.fill.svg" alt=""> <br>
            {{ 'orderDetails.deliveryForm.deliveryType.delivery' | translate }}
          </button>
          <button class="delivery-type-btn" [class.active]="deliveryType === 'pickup'"
            (click)="deliveryType = 'pickup'; onDeliveryTypeChange()">
            <img src="../../../assets/bag.fill.svg" alt=""> <br>
            {{ 'orderDetails.deliveryForm.deliveryType.pickup' | translate }}
          </button>
        </div>
      </div>

      <!-- Address Field (shown only for delivery) -->
      <div class="form-section" *ngIf="deliveryType === 'delivery'">
        <div class="delivery-method-wrapper">
          <i class="section-icon icon-address" aria-hidden="true"></i>
          <label class="form-label">{{ 'orderDetails.deliveryForm.address.label' | translate }}</label>
        </div>
        <hr>
        <textarea *ngIf="!isAddressReadOnly" [(ngModel)]="deliveryAddress"
          [placeholder]="'orderDetails.deliveryForm.address.placeholder' | translate" class="form-input" rows="3"
          (ngModelChange)="onDeliveryAddressInput()"
          (blur)="validateAddress()">
        </textarea>
        <div class="delivery-data-wrapper" *ngIf="isAddressReadOnly">
          <div *ngIf="deliveryData.title">
            <img src="../../../assets/delivery-title.svg" alt="">
            <p>{{deliveryData.title}}</p>
          </div>
          <div>
            <img src="../../../assets/delivery-location.svg" alt="">
            <p>{{deliveryData.address}}</p>
          </div>
          <div *ngIf="deliveryData.description">
            <img src="../../../assets/delivery-info.svg" alt="">
            <p>{{deliveryData.description}}</p>
          </div>
        </div>
        <span class="error-message" *ngIf="addressError">{{ addressError }}</span>

        <!-- Delivery pricing: only on a venue that prices delivery. The address is looked up
             on its own once the guest stops typing, and the pin is sent for pricing straight
             away; the map is only for fine-tuning, or for placing the pin by hand when the
             address was not found. The fee, the total and any message are the server's. -->
        <ng-container *ngIf="usesDeliveryPricing">
          <p class="delivery-map-hint" *ngIf="isGeocoding">{{ 'orderDetails.delivery.finding' | translate }}</p>

          <!-- "Adjust on map" is there from the start, even with no address typed: the map then
               opens on the venue. -->
          <div class="delivery-location-found" *ngIf="!isMapOpen && !isGeocoding">
            <span class="delivery-location-status">
              <ng-container *ngIf="hasPinForAddress && !addressNotFound && effectiveAddress.trim()">✓ {{ 'orderDetails.delivery.locationFound' | translate }}</ng-container>
            </span>
            <button type="button" class="delivery-link-button" (click)="openDeliveryMap()">
              {{ 'orderDetails.delivery.adjustOnMap' | translate }}
            </button>
          </div>

          <ng-container *ngIf="isMapOpen">
            <p class="delivery-map-hint is-blocking" *ngIf="addressNotFound">
              {{ 'orderDetails.delivery.notFound' | translate }}
            </p>
            <!-- The header names the place the pin is on: the typed address until the guest
                 moves it, then the address found at the pin, which replaces the typed text on
                 Confirm. -->
            <p class="delivery-map-header">
              <ng-container *ngIf="isReverseGeocoding; else mapHeaderText">
                {{ 'orderDetails.delivery.mapAddressLoading' | translate }}
              </ng-container>
              <ng-template #mapHeaderText>
                {{ mapHeaderAddress || ((isAddressFieldEmpty ? 'orderDetails.delivery.mapAddressUnknownEmpty' : 'orderDetails.delivery.mapAddressUnknown') | translate) }}
              </ng-template>
            </p>
            <div class="delivery-map-wrap">
              <div #deliveryMapHost class="delivery-map"></div>
              <!-- The guest's pin: fixed over the map's centre, its tip on the centre point.
                   The map moves under it; it is not a Leaflet marker. -->
              <span class="delivery-centre-pin" aria-hidden="true"></span>
              <button type="button" class="delivery-venue-button" *ngIf="deliverySettings.venue" (click)="movePinToVenue()">
                {{ 'orderDetails.delivery.backToVenue' | translate }}
              </button>
            </div>
            <p class="delivery-map-hint">{{ 'orderDetails.delivery.dragHint' | translate }}</p>
            <button type="button" class="delivery-confirm-button" *ngIf="!isLocationConfirmed"
              [disabled]="isPricingDelivery || isReverseGeocoding" (click)="confirmDeliveryLocation()">
              {{ (isPricingDelivery ? 'orderDetails.delivery.checking' : 'orderDetails.delivery.confirm') | translate }}
            </button>
          </ng-container>

          <p class="delivery-map-hint" *ngIf="isPricingDelivery && !isMapOpen">
            {{ 'orderDetails.delivery.checking' | translate }}
          </p>

          <div class="delivery-quote" *ngIf="isLocationConfirmed && deliveryQuote">
            <div class="delivery-quote-row" *ngIf="deliveryFee !== null">
              <span>{{ (deliveryFee > 0 ? 'orderDetails.delivery.label' : 'orderDetails.delivery.free') | translate }}</span>
              <span *ngIf="deliveryFee > 0">{{ deliveryFee | number:'1.2-2' }} <span [innerHTML]="currencySymbol"></span></span>
            </div>
            <div class="delivery-quote-row delivery-quote-total">
              <span>{{ 'orderDetails.orderDrawer.summary.total' | translate }}</span>
              <span>{{ orderTotal | number:'1.2-2' }} <span [innerHTML]="currencySymbol"></span></span>
            </div>
            <ng-container [ngSwitch]="deliveryQuote.status">
              <ng-container *ngSwitchCase="'out_of_range'">
                <p class="delivery-quote-message is-blocking">
                  {{ 'orderDetails.delivery.outOfRange' | translate }}
                </p>
                <!-- The pin was the geocoder's guess, which may simply be wrong. -->
                <button type="button" class="delivery-link-button" *ngIf="suggestAdjustingPin" (click)="openDeliveryMap()">
                  {{ 'orderDetails.delivery.adjustHint' | translate }}
                </button>
              </ng-container>
              <p class="delivery-quote-message is-blocking" *ngSwitchCase="'below_minimum'"
                [innerHTML]="'orderDetails.delivery.belowMinimum' | translate: { amount: formatDeliveryAmount(deliveryQuote.missingForMinimum) }">
              </p>
              <p class="delivery-quote-message is-blocking" *ngSwitchCase="'not_offered'">
                {{ 'orderDetails.delivery.errors.notOffered' | translate }}
              </p>
              <ng-container *ngSwitchCase="'ok'">
                <p class="delivery-quote-message" *ngIf="deliveryQuote.missingForFree"
                  [innerHTML]="'orderDetails.delivery.missingForFree' | translate: { amount: formatDeliveryAmount(deliveryQuote.missingForFree) }">
                </p>
              </ng-container>
            </ng-container>
          </div>

          <span class="error-message" *ngIf="deliveryErrorKey">
            {{ 'orderDetails.delivery.errors.' + deliveryErrorKey | translate }}
          </span>
        </ng-container>
      </div>

      <!-- Pickup Location (shown for pickup orders) -->
      <div class="form-section" *ngIf="deliveryType === 'pickup' && pickupLocations.length > 0">
        <div class="delivery-method-wrapper">
          <i class="section-icon icon-address" aria-hidden="true"></i>
          <label class="form-label">{{ 'orderDetails.deliveryForm.pickupLocation.label' | translate }}</label>
        </div>
        <hr>
        <!-- Show dropdown if multiple locations -->
        <select *ngIf="pickupLocations.length > 1" [(ngModel)]="pickupLocationId" class="form-select"
          (change)="validatePickupLocation()">
          <option value="">{{ 'orderDetails.deliveryForm.pickupLocation.select' | translate }}</option>
          <option *ngFor="let location of pickupLocations" [value]="location.id">
            {{ location.name }}
          </option>
        </select>
        <!-- Show read-only field if single location -->
        <div *ngIf="pickupLocations.length === 1" class="delivery-data-wrapper">
          <div>
            <img src="../../../assets/delivery-location.svg" alt="">
            <p>{{pickupLocations[0].name}}</p>
          </div>
          <div *ngIf="pickupLocations[0].address">
            <img src="../../../assets/delivery-info.svg" alt="">
            <p>{{pickupLocations[0].address}}</p>
          </div>
        </div>
        <span class="error-message" *ngIf="pickupLocationError">{{ pickupLocationError }}</span>
      </div>

      <!-- Phone Field -->
      <div class="form-section">
        <div class="delivery-method-wrapper">
          <i class="section-icon icon-phone" aria-hidden="true"></i>
          <label class="form-label">{{ 'orderDetails.deliveryForm.phone.label' | translate }}</label>
        </div>
        <hr>
        <div class="phone-input-wrapper">
          <button type="button" class="country-code-button" (click)="openCountrySelector()">
            <span>{{ selectedCountryCode.flag }} {{ selectedCountryCode.code }}</span>
            <img src="../../../assets/chevron-down.svg" alt="" class="chevron-icon">
          </button>
          <div class="phone-input-container">
            <input type="tel" [(ngModel)]="phoneNumber"
              [placeholder]="'orderDetails.deliveryForm.phone.placeholder' | translate"
              class="form-input phone-number-input" [class.valid]="isPhoneValid"
              [maxlength]="selectedCountryCode.maxLength + 5" (input)="validatePhone(false)"
              (blur)="validatePhone(true)">
            <img *ngIf="isPhoneValid" src="../../../assets/success.svg" alt="Valid" class="phone-checkmark">
          </div>
        </div>
        <span class="error-message" *ngIf="phoneError">{{ phoneError }}</span>
      </div>

      <!-- Communication Preference -->
      <div class="form-section">
        <div class="delivery-method-wrapper">
          <i class="section-icon icon-message" aria-hidden="true"></i>
          <label class="form-label">{{ 'orderDetails.deliveryForm.communication.label' | translate }}</label>
        </div>
        <hr>
        <div class="communication-dropdown-wrapper" (click)="$event.stopPropagation()">
          <button type="button" class="communication-select-button" (click)="toggleCommunicationDropdown()"
            [class.open]="isCommunicationDropdownOpen">
            <div class="communication-option-display">
              <span>{{ getCommunicationLabel(communicationPreference) | translate }}</span>
            </div>
            <img src="../../../assets/chevron-down.svg" alt="" class="chevron-icon"
              [class.rotated]="isCommunicationDropdownOpen">
          </button>
          <div class="communication-dropdown" [class.open]="isCommunicationDropdownOpen">
            <div class="communication-option" *ngFor="let option of getCommunicationOptions()"
              [class.selected]="communicationPreference === option" (click)="selectCommunicationPreference(option)">
              <span>{{ getCommunicationLabel(option) | translate }}</span>
              <img [src]="getCommunicationLogo(option)" alt="" class="communication-logo">
            </div>
          </div>
        </div>
      </div>
      <!-- Payment Method Picker. Shown once the guest has chosen delivery or pickup and
           the venue accepts anything for it — a single method is still a sentence they
           need. Each row says where and when the money actually moves. -->
      <div class="form-section" *ngIf="shouldShowPaymentMethodPicker()">
        <div class="delivery-method-wrapper">
          <i class="section-icon icon-payment" aria-hidden="true"></i>
          <label class="form-label">{{ 'orderDetails.paymentMethod.label' | translate }}</label>
        </div>
        <hr>
        <div class="payment-rows">
          <button *ngFor="let row of paymentRows"
            type="button"
            class="payment-row"
            [class.active]="paymentMethod === row.method"
            [attr.aria-pressed]="paymentMethod === row.method"
            (click)="selectPaymentMethod(row.method)">
            <span class="row-title">{{ row.titleKey | translate }}</span>
            <span class="row-subtitle" *ngIf="row.subtitleKey">{{ row.subtitleKey | translate }}</span>
          </button>
        </div>
      </div>

      <!-- Tip, right under the payment section and only while Online payment is chosen:
           the server drops the tip from an order paid any other way. Last in the form, so
           it scrolls itself into view when the guest picks Online. -->
      <app-tip-picker
        *ngIf="showTipPicker"
        [settings]="tipSettings"
        [selected]="selectedTip"
        [amount]="tipAmount"
        [currencySymbol]="currencySymbol"
        [error]="tipErrorKey"
        [revealOnShow]="tipRevealOnShow"
        (choose)="onTipChosen($event)">
      </app-tip-picker>
    </div>

    <div class="form-footer">
      <button class="cancel-button" (click)="closeForm()">
        {{ 'orderDetails.deliveryForm.cancel' | translate }}
      </button>
      <button class="submit-button" [disabled]="!isFormValid()" (click)="onSubmitForm()">
        {{ submitLabelKey | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Country Selector Modal -->
<div class="country-selector-modal" [class.open]="isCountrySelectorOpen" (click)="closeCountrySelector()">
  <div class="country-selector-content" (click)="$event.stopPropagation()">
    <div class="country-selector-header">
      <h2>{{ 'orderDetails.countrySelector.title' | translate }}</h2>
      <button class="close-button" (click)="closeCountrySelector()">
        <img src="../../../assets/x.svg" alt="Close">
      </button>
    </div>

    <div class="country-search-wrapper">
      <input type="text" [(ngModel)]="countrySearchQuery" (input)="filterCountries()"
        [placeholder]="'orderDetails.countrySelector.searchPlaceholder' | translate" class="country-search-input">
    </div>

    <div class="country-list">
      <div *ngFor="let country of filteredCountries" class="country-item"
        [class.selected]="selectedCountryCode.code === country.code" (click)="selectCountry(country)">
        <span class="country-flag">{{ country.flag }}</span>
        <div class="country-info">
          <span class="country-name">{{ country.name }}</span>
          <span class="country-code">{{ country.code }}</span>
        </div>
        <span class="check-icon" *ngIf="selectedCountryCode.code === country.code">✓</span>
      </div>
      <div class="no-results" *ngIf="filteredCountries.length === 0">
        <p>{{ 'orderDetails.countrySelector.noResults' | translate }}</p>
      </div>
    </div>
  </div>
</div>

